import { useUserCapabilities } from '#pplx/frontend/apps/ask/queries/user-queries/useUserCapabilities.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import { useCallback } from 'react';
/**
 * Provides a callback function that determines whether or not the user is
 * allowed to upload files. This hook performs pure validation without side effects.
 *
 * Validation checks (in order):
 * 1. Authentication - User must be signed in (unless they have special file upload capability)
 * 2. Rate Limit - User must have remaining upload quota
 *
 * @returns A callback function that determines if the user can upload a file
 */
export function useCanUploadFile({ uploadRateLimit }) {
    const isUserLoggedIn = useIsUserLoggedIn();
    const { specialCapabilities } = useUserCapabilities();
    return useCallback(() => {
        // Check 1: Authentication
        if (!isUserLoggedIn && !specialCapabilities.fileUpload) {
            return { canUpload: false, reason: 'auth' };
        }
        // Check 2: Rate Limit
        if (uploadRateLimit !== null && uploadRateLimit !== undefined && uploadRateLimit <= 0) {
            return { canUpload: false, reason: 'rate_limit' };
        }
        return { canUpload: true };
    }, [isUserLoggedIn, uploadRateLimit, specialCapabilities.fileUpload]);
}
//# sourceMappingURL=useCanUploadFile.js.map